import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { ThemeProvider } from 'styled-components';
import './index.css';
import './i18n';
import App from './App';
import { theme } from './theme';
import { ErrorFallback } from './ErrorPages/ErrorFallback';

// Baked in at build time (see Dockerfile's ARG/ENV pair) — absent in local
// dev, where Sentry.init would otherwise just log a harmless DSN warning.
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV,
    sendDefaultPii: false,
    tracesSampleRate: 0,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Sentry.ErrorBoundary fallback={<ErrorFallback/>}>
        <App />
      </Sentry.ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>
);
